// src/js/main/comparison.js

import { initializeSmartComparison } from '../components/smartComparison.js';

document.addEventListener('DOMContentLoaded', () => {
    initializeSmartComparison();
});